export { default as AllstarLogoPurple } from "@ugitgud/legos/assets/lib/shared/icon/allstar/allstar-logo-purple.webp";
export { default as AbilityAstraC } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-astra-c.webp";
export { default as AbilityAstraE } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-astra-e.webp";
export { default as AbilityAstraPassive } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-astra-passive.webp";
export { default as AbilityAstraQ } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-astra-q.webp";
export { default as AbilityAstraUlt } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-astra-ult.webp";
export { default as AbilityBreachC } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-breach-c.webp";
export { default as AbilityBreachE } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-breach-e.webp";
export { default as AbilityBreachQ } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-breach-q.webp";
export { default as AbilityBreachUlt } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-breach-ult.webp";
export { default as AbilityBrimstoneC } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-brimstone-c.webp";
export { default as AbilityBrimstoneE } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-brimstone-e.webp";
export { default as AbilityBrimstoneQ } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-brimstone-q.webp";
export { default as AbilityBrimstoneUlt } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-brimstone-ult.webp";
export { default as AbilityChamberC } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-chamber-c.webp";
export { default as AbilityChamberE } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-chamber-e.webp";
export { default as AbilityChamberQ } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-chamber-q.webp";
export { default as AbilityChamberUlt } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-chamber-ult.webp";
export { default as AbilityCloveC } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-clove-c.webp";
export { default as AbilityCloveE } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-clove-e.webp";
export { default as AbilityCloveQ } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-clove-q.webp";
export { default as AbilityCloveUlt } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-clove-ult.webp";
export { default as AbilityCypherC } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-cypher-c.webp";
export { default as AbilityCypherE } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-cypher-e.webp";
export { default as AbilityCypherQ } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-cypher-q.webp";
export { default as AbilityCypherUlt } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-cypher-ult.webp";
export { default as AbilityDeadlockC } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-deadlock-c.webp";
export { default as AbilityDeadlockE } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-deadlock-e.webp";
export { default as AbilityDeadlockQ } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-deadlock-q.webp";
export { default as AbilityDeadlockUlt } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-deadlock-ult.webp";
export { default as AbilityFadeC } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-fade-c.webp";
export { default as AbilityFadeE } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-fade-e.webp";
export { default as AbilityFadeQ } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-fade-q.webp";
export { default as AbilityFadeUlt } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-fade-ult.webp";
export { default as AbilityGekkoC } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-gekko-c.webp";
export { default as AbilityGekkoE } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-gekko-e.webp";
export { default as AbilityGekkoQ } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-gekko-q.webp";
export { default as AbilityGekkoUlt } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-gekko-ult.webp";
export { default as AbilityHarborC } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-harbor-c.webp";
export { default as AbilityHarborE } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-harbor-e.webp";
export { default as AbilityHarborQ } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-harbor-q.webp";
export { default as AbilityHarborUlt } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-harbor-ult.webp";
export { default as AbilityIsoC } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-iso-c.webp";
export { default as AbilityIsoE } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-iso-e.webp";
export { default as AbilityIsoQ } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-iso-q.webp";
export { default as AbilityIsoUlt } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-iso-ult.webp";
export { default as AbilityJettC } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-jett-c.webp";
export { default as AbilityJettE } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-jett-e.webp";
export { default as AbilityJettPassive } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-jett-passive.webp";
export { default as AbilityJettQ } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-jett-q.webp";
export { default as AbilityJettUlt } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-jett-ult.webp";
export { default as AbilityKayoC } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-kayo-c.webp";
export { default as AbilityKayoE } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-kayo-e.webp";
export { default as AbilityKayoQ } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-kayo-q.webp";
export { default as AbilityKayoUlt } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-kayo-ult.webp";
export { default as AbilityKilljoyC } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-killjoy-c.webp";
export { default as AbilityKilljoyE } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-killjoy-e.webp";
export { default as AbilityKilljoyQ } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-killjoy-q.webp";
export { default as AbilityKilljoyUlt } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-killjoy-ult.webp";
export { default as AbilityNeonC } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-neon-c.webp";
export { default as AbilityNeonE } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-neon-e.webp";
export { default as AbilityNeonQ } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-neon-q.webp";
export { default as AbilityNeonUlt } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-neon-ult.webp";
export { default as AbilityOmenC } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-omen-c.webp";
export { default as AbilityOmenE } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-omen-e.webp";
export { default as AbilityOmenQ } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-omen-q.webp";
export { default as AbilityOmenUlt } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-omen-ult.webp";
export { default as AbilityPhoenixC } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-phoenix-c.webp";
export { default as AbilityPhoenixE } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-phoenix-e.webp";
export { default as AbilityPhoenixQ } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-phoenix-q.webp";
export { default as AbilityPhoenixUlt } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-phoenix-ult.webp";
export { default as AbilityRazeC } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-raze-c.webp";
export { default as AbilityRazeE } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-raze-e.webp";
export { default as AbilityRazeQ } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-raze-q.webp";
export { default as AbilityRazeUlt } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-raze-ult.webp";
export { default as AbilityReynaC } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-reyna-c.webp";
export { default as AbilityReynaE } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-reyna-e.webp";
export { default as AbilityReynaQ } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-reyna-q.webp";
export { default as AbilityReynaUlt } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-reyna-ult.webp";
export { default as AbilitySageC } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-sage-c.webp";
export { default as AbilitySageE } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-sage-e.webp";
export { default as AbilitySageQ } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-sage-q.webp";
export { default as AbilitySageUlt } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-sage-ult.webp";
export { default as AbilitySkyeC } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-skye-c.webp";
export { default as AbilitySkyeE } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-skye-e.webp";
export { default as AbilitySkyeQ } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-skye-q.webp";
export { default as AbilitySkyeUlt } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-skye-ult.webp";
export { default as AbilitySovaC } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-sova-c.webp";
export { default as AbilitySovaE } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-sova-e.webp";
export { default as AbilitySovaQ } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-sova-q.webp";
export { default as AbilitySovaUlt } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-sova-ult.webp";
export { default as AbilityTejoC } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-tejo-c.webp";
export { default as AbilityTejoE } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-tejo-e.webp";
export { default as AbilityTejoQ } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-tejo-q.webp";
export { default as AbilityTejoUlt } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-tejo-ult.webp";
export { default as AbilityViperC } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-viper-c.webp";
export { default as AbilityViperE } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-viper-e.webp";
export { default as AbilityViperQ } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-viper-q.webp";
export { default as AbilityViperUlt } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-viper-ult.webp";
export { default as AbilityVyseC } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-vyse-c.webp";
export { default as AbilityVyseE } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-vyse-e.webp";
export { default as AbilityVyseQ } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-vyse-q.webp";
export { default as AbilityVyseUlt } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-vyse-ult.webp";
export { default as AbilityWaylayC } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-waylay-c.webp";
export { default as AbilityWaylayE } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-waylay-e.webp";
export { default as AbilityWaylayQ } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-waylay-q.webp";
export { default as AbilityWaylayUlt } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-waylay-ult.webp";
export { default as AbilityYoruC } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-yoru-c.webp";
export { default as AbilityYoruE } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-yoru-e.webp";
export { default as AbilityYoruQ } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-yoru-q.webp";
export { default as AbilityYoruUlt } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-yoru-ult.webp";
export { default as AgentAstra } from "@ugitgud/legos/assets/lib/valorant/icon/agents/agent-astra.webp";
export { default as AgentBreach } from "@ugitgud/legos/assets/lib/valorant/icon/agents/agent-breach.webp";
export { default as AgentBrimstone } from "@ugitgud/legos/assets/lib/valorant/icon/agents/agent-brimstone.webp";
export { default as AgentChamber } from "@ugitgud/legos/assets/lib/valorant/icon/agents/agent-chamber.webp";
export { default as AgentClove } from "@ugitgud/legos/assets/lib/valorant/icon/agents/agent-clove.webp";
export { default as AgentCypher } from "@ugitgud/legos/assets/lib/valorant/icon/agents/agent-cypher.webp";
export { default as AgentDeadlock } from "@ugitgud/legos/assets/lib/valorant/icon/agents/agent-deadlock.webp";
export { default as AgentFade } from "@ugitgud/legos/assets/lib/valorant/icon/agents/agent-fade.webp";
export { default as AgentGekko } from "@ugitgud/legos/assets/lib/valorant/icon/agents/agent-gekko.webp";
export { default as AgentHarbor } from "@ugitgud/legos/assets/lib/valorant/icon/agents/agent-harbor.webp";
export { default as AgentIso } from "@ugitgud/legos/assets/lib/valorant/icon/agents/agent-iso.webp";
export { default as AgentJett } from "@ugitgud/legos/assets/lib/valorant/icon/agents/agent-jett.webp";
export { default as AgentKayo } from "@ugitgud/legos/assets/lib/valorant/icon/agents/agent-kayo.webp";
export { default as AgentKilljoy } from "@ugitgud/legos/assets/lib/valorant/icon/agents/agent-killjoy.webp";
export { default as AgentNeon } from "@ugitgud/legos/assets/lib/valorant/icon/agents/agent-neon.webp";
export { default as AgentOmen } from "@ugitgud/legos/assets/lib/valorant/icon/agents/agent-omen.webp";
export { default as AgentPhoenix } from "@ugitgud/legos/assets/lib/valorant/icon/agents/agent-phoenix.webp";
export { default as AgentRaze } from "@ugitgud/legos/assets/lib/valorant/icon/agents/agent-raze.webp";
export { default as AgentReyna } from "@ugitgud/legos/assets/lib/valorant/icon/agents/agent-reyna.webp";
export { default as AgentSage } from "@ugitgud/legos/assets/lib/valorant/icon/agents/agent-sage.webp";
export { default as AgentSkye } from "@ugitgud/legos/assets/lib/valorant/icon/agents/agent-skye.webp";
export { default as AgentSova } from "@ugitgud/legos/assets/lib/valorant/icon/agents/agent-sova.webp";
export { default as AgentTejo } from "@ugitgud/legos/assets/lib/valorant/icon/agents/agent-tejo.webp";
export { default as AgentViper } from "@ugitgud/legos/assets/lib/valorant/icon/agents/agent-viper.webp";
export { default as AgentVyse } from "@ugitgud/legos/assets/lib/valorant/icon/agents/agent-vyse.webp";
export { default as AgentWaylay } from "@ugitgud/legos/assets/lib/valorant/icon/agents/agent-waylay.webp";
export { default as AgentYoru } from "@ugitgud/legos/assets/lib/valorant/icon/agents/agent-yoru.webp";
export { default as PremierConferenceApac } from "@ugitgud/legos/assets/lib/valorant/icon/premier-conference/premier-conference-apac.webp";
export { default as PremierConferenceAus } from "@ugitgud/legos/assets/lib/valorant/icon/premier-conference/premier-conference-aus.webp";
export { default as PremierConferenceBr } from "@ugitgud/legos/assets/lib/valorant/icon/premier-conference/premier-conference-br.webp";
export { default as PremierConferenceEu } from "@ugitgud/legos/assets/lib/valorant/icon/premier-conference/premier-conference-eu.webp";
export { default as PremierConferenceInd } from "@ugitgud/legos/assets/lib/valorant/icon/premier-conference/premier-conference-ind.webp";
export { default as PremierConferenceJpn } from "@ugitgud/legos/assets/lib/valorant/icon/premier-conference/premier-conference-jpn.webp";
export { default as PremierConferenceKr } from "@ugitgud/legos/assets/lib/valorant/icon/premier-conference/premier-conference-kr.webp";
export { default as PremierConferenceLatam } from "@ugitgud/legos/assets/lib/valorant/icon/premier-conference/premier-conference-latam.webp";
export { default as PremierConferenceMe } from "@ugitgud/legos/assets/lib/valorant/icon/premier-conference/premier-conference-me.webp";
export { default as PremierConferenceNa } from "@ugitgud/legos/assets/lib/valorant/icon/premier-conference/premier-conference-na.webp";
export { default as PremierConferenceTr } from "@ugitgud/legos/assets/lib/valorant/icon/premier-conference/premier-conference-tr.webp";
export { default as PremierConferenceUs } from "@ugitgud/legos/assets/lib/valorant/icon/premier-conference/premier-conference-us.webp";
export { default as PremierDivisionAdvanced } from "@ugitgud/legos/assets/lib/valorant/icon/premier-division/premier-division-advanced.webp";
export { default as PremierDivisionContender } from "@ugitgud/legos/assets/lib/valorant/icon/premier-division/premier-division-contender.webp";
export { default as PremierDivisionElite } from "@ugitgud/legos/assets/lib/valorant/icon/premier-division/premier-division-elite.webp";
export { default as PremierDivisionIntermediate } from "@ugitgud/legos/assets/lib/valorant/icon/premier-division/premier-division-intermediate.webp";
export { default as PremierDivisionInvite } from "@ugitgud/legos/assets/lib/valorant/icon/premier-division/premier-division-invite.webp";
export { default as PremierDivisionOpen } from "@ugitgud/legos/assets/lib/valorant/icon/premier-division/premier-division-open.webp";
export { default as PremierDivisionUnknown } from "@ugitgud/legos/assets/lib/valorant/icon/premier-division/premier-division-unknown.webp";
export { default as Rank_0 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-0.webp";
export { default as Rank_10 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-10.webp";
export { default as Rank_11 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-11.webp";
export { default as Rank_12 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-12.webp";
export { default as Rank_13 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-13.webp";
export { default as Rank_14 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-14.webp";
export { default as Rank_15 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-15.webp";
export { default as Rank_16 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-16.webp";
export { default as Rank_17 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-17.webp";
export { default as Rank_18 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-18.webp";
export { default as Rank_19 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-19.webp";
export { default as Rank_20 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-20.webp";
export { default as Rank_21 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-21.webp";
export { default as Rank_22 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-22.webp";
export { default as Rank_23 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-23.webp";
export { default as Rank_24 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-24.webp";
export { default as Rank_25 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-25.webp";
export { default as Rank_26 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-26.webp";
export { default as Rank_27 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-27.webp";
export { default as Rank_3 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-3.webp";
export { default as Rank_4 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-4.webp";
export { default as Rank_5 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-5.webp";
export { default as Rank_6 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-6.webp";
export { default as Rank_7 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-7.webp";
export { default as Rank_8 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-8.webp";
export { default as Rank_9 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-9.webp";
export { default as RankEp_1_0 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-1-0.webp";
export { default as RankEp_1_10 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-1-10.webp";
export { default as RankEp_1_11 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-1-11.webp";
export { default as RankEp_1_12 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-1-12.webp";
export { default as RankEp_1_13 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-1-13.webp";
export { default as RankEp_1_14 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-1-14.webp";
export { default as RankEp_1_15 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-1-15.webp";
export { default as RankEp_1_16 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-1-16.webp";
export { default as RankEp_1_17 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-1-17.webp";
export { default as RankEp_1_18 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-1-18.webp";
export { default as RankEp_1_19 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-1-19.webp";
export { default as RankEp_1_20 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-1-20.webp";
export { default as RankEp_1_21 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-1-21.webp";
export { default as RankEp_1_22 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-1-22.webp";
export { default as RankEp_1_23 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-1-23.webp";
export { default as RankEp_1_24 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-1-24.webp";
export { default as RankEp_1_3 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-1-3.webp";
export { default as RankEp_1_4 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-1-4.webp";
export { default as RankEp_1_5 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-1-5.webp";
export { default as RankEp_1_6 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-1-6.webp";
export { default as RankEp_1_7 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-1-7.webp";
export { default as RankEp_1_8 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-1-8.webp";
export { default as RankEp_1_9 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-1-9.webp";
export { default as RankEp_2_0 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-2-0.webp";
export { default as RankEp_2_10 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-2-10.webp";
export { default as RankEp_2_11 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-2-11.webp";
export { default as RankEp_2_12 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-2-12.webp";
export { default as RankEp_2_13 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-2-13.webp";
export { default as RankEp_2_14 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-2-14.webp";
export { default as RankEp_2_15 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-2-15.webp";
export { default as RankEp_2_16 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-2-16.webp";
export { default as RankEp_2_17 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-2-17.webp";
export { default as RankEp_2_18 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-2-18.webp";
export { default as RankEp_2_19 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-2-19.webp";
export { default as RankEp_2_20 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-2-20.webp";
export { default as RankEp_2_21 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-2-21.webp";
export { default as RankEp_2_24 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-2-24.webp";
export { default as RankEp_2_3 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-2-3.webp";
export { default as RankEp_2_4 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-2-4.webp";
export { default as RankEp_2_5 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-2-5.webp";
export { default as RankEp_2_6 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-2-6.webp";
export { default as RankEp_2_7 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-2-7.webp";
export { default as RankEp_2_8 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-2-8.webp";
export { default as RankEp_2_9 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-2-9.webp";
export { default as RankEp_3_0 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-3-0.webp";
export { default as RankEp_3_10 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-3-10.webp";
export { default as RankEp_3_11 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-3-11.webp";
export { default as RankEp_3_12 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-3-12.webp";
export { default as RankEp_3_13 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-3-13.webp";
export { default as RankEp_3_14 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-3-14.webp";
export { default as RankEp_3_15 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-3-15.webp";
export { default as RankEp_3_16 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-3-16.webp";
export { default as RankEp_3_17 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-3-17.webp";
export { default as RankEp_3_18 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-3-18.webp";
export { default as RankEp_3_19 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-3-19.webp";
export { default as RankEp_3_20 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-3-20.webp";
export { default as RankEp_3_21 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-3-21.webp";
export { default as RankEp_3_22 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-3-22.webp";
export { default as RankEp_3_23 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-3-23.webp";
export { default as RankEp_3_24 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-3-24.webp";
export { default as RankEp_3_3 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-3-3.webp";
export { default as RankEp_3_4 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-3-4.webp";
export { default as RankEp_3_5 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-3-5.webp";
export { default as RankEp_3_6 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-3-6.webp";
export { default as RankEp_3_7 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-3-7.webp";
export { default as RankEp_3_8 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-3-8.webp";
export { default as RankEp_3_9 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-3-9.webp";
export { default as RankEp_4_0 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-4-0.webp";
export { default as RankEp_4_10 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-4-10.webp";
export { default as RankEp_4_11 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-4-11.webp";
export { default as RankEp_4_12 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-4-12.webp";
export { default as RankEp_4_13 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-4-13.webp";
export { default as RankEp_4_14 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-4-14.webp";
export { default as RankEp_4_15 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-4-15.webp";
export { default as RankEp_4_16 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-4-16.webp";
export { default as RankEp_4_17 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-4-17.webp";
export { default as RankEp_4_18 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-4-18.webp";
export { default as RankEp_4_19 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-4-19.webp";
export { default as RankEp_4_20 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-4-20.webp";
export { default as RankEp_4_21 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-4-21.webp";
export { default as RankEp_4_22 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-4-22.webp";
export { default as RankEp_4_23 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-4-23.webp";
export { default as RankEp_4_24 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-4-24.webp";
export { default as RankEp_4_3 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-4-3.webp";
export { default as RankEp_4_4 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-4-4.webp";
export { default as RankEp_4_5 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-4-5.webp";
export { default as RankEp_4_6 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-4-6.webp";
export { default as RankEp_4_7 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-4-7.webp";
export { default as RankEp_4_8 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-4-8.webp";
export { default as RankEp_4_9 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-4-9.webp";
export { default as RankEp_5_0 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-5-0.webp";
export { default as RankEp_5_10 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-5-10.webp";
export { default as RankEp_5_11 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-5-11.webp";
export { default as RankEp_5_12 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-5-12.webp";
export { default as RankEp_5_13 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-5-13.webp";
export { default as RankEp_5_14 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-5-14.webp";
export { default as RankEp_5_15 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-5-15.webp";
export { default as RankEp_5_16 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-5-16.webp";
export { default as RankEp_5_17 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-5-17.webp";
export { default as RankEp_5_18 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-5-18.webp";
export { default as RankEp_5_19 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-5-19.webp";
export { default as RankEp_5_20 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-5-20.webp";
export { default as RankEp_5_21 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-5-21.webp";
export { default as RankEp_5_22 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-5-22.webp";
export { default as RankEp_5_23 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-5-23.webp";
export { default as RankEp_5_24 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-5-24.webp";
export { default as RankEp_5_25 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-5-25.webp";
export { default as RankEp_5_26 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-5-26.webp";
export { default as RankEp_5_27 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-5-27.webp";
export { default as RankEp_5_3 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-5-3.webp";
export { default as RankEp_5_4 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-5-4.webp";
export { default as RankEp_5_5 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-5-5.webp";
export { default as RankEp_5_6 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-5-6.webp";
export { default as RankEp_5_7 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-5-7.webp";
export { default as RankEp_5_8 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-5-8.webp";
export { default as RankEp_5_9 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-5-9.webp";
export { default as WeaponAres } from "@ugitgud/legos/assets/lib/valorant/icon/weapons/weapon-ares.webp";
export { default as WeaponBucky } from "@ugitgud/legos/assets/lib/valorant/icon/weapons/weapon-bucky.webp";
export { default as WeaponBulldog } from "@ugitgud/legos/assets/lib/valorant/icon/weapons/weapon-bulldog.webp";
export { default as WeaponClassic } from "@ugitgud/legos/assets/lib/valorant/icon/weapons/weapon-classic.webp";
export { default as WeaponFrenzy } from "@ugitgud/legos/assets/lib/valorant/icon/weapons/weapon-frenzy.webp";
export { default as WeaponGhost } from "@ugitgud/legos/assets/lib/valorant/icon/weapons/weapon-ghost.webp";
export { default as WeaponGuardian } from "@ugitgud/legos/assets/lib/valorant/icon/weapons/weapon-guardian.webp";
export { default as WeaponHeadhunter } from "@ugitgud/legos/assets/lib/valorant/icon/weapons/weapon-headhunter.webp";
export { default as WeaponJudge } from "@ugitgud/legos/assets/lib/valorant/icon/weapons/weapon-judge.webp";
export { default as WeaponMarshal } from "@ugitgud/legos/assets/lib/valorant/icon/weapons/weapon-marshal.webp";
export { default as WeaponMelee } from "@ugitgud/legos/assets/lib/valorant/icon/weapons/weapon-melee.webp";
export { default as WeaponOdin } from "@ugitgud/legos/assets/lib/valorant/icon/weapons/weapon-odin.webp";
export { default as WeaponOperator } from "@ugitgud/legos/assets/lib/valorant/icon/weapons/weapon-operator.webp";
export { default as WeaponOutlaw } from "@ugitgud/legos/assets/lib/valorant/icon/weapons/weapon-outlaw.webp";
export { default as WeaponPhantom } from "@ugitgud/legos/assets/lib/valorant/icon/weapons/weapon-phantom.webp";
export { default as WeaponSheriff } from "@ugitgud/legos/assets/lib/valorant/icon/weapons/weapon-sheriff.webp";
export { default as WeaponShorty } from "@ugitgud/legos/assets/lib/valorant/icon/weapons/weapon-shorty.webp";
export { default as WeaponSpectre } from "@ugitgud/legos/assets/lib/valorant/icon/weapons/weapon-spectre.webp";
export { default as WeaponStinger } from "@ugitgud/legos/assets/lib/valorant/icon/weapons/weapon-stinger.webp";
export { default as WeaponTourDeForce } from "@ugitgud/legos/assets/lib/valorant/icon/weapons/weapon-tour-de-force.webp";
export { default as WeaponVandal } from "@ugitgud/legos/assets/lib/valorant/icon/weapons/weapon-vandal.webp";
import { default as AllstarLogoPurple } from "@ugitgud/legos/assets/lib/shared/icon/allstar/allstar-logo-purple.webp";
import { default as AbilityAstraC } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-astra-c.webp";
import { default as AbilityAstraE } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-astra-e.webp";
import { default as AbilityAstraPassive } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-astra-passive.webp";
import { default as AbilityAstraQ } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-astra-q.webp";
import { default as AbilityAstraUlt } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-astra-ult.webp";
import { default as AbilityBreachC } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-breach-c.webp";
import { default as AbilityBreachE } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-breach-e.webp";
import { default as AbilityBreachQ } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-breach-q.webp";
import { default as AbilityBreachUlt } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-breach-ult.webp";
import { default as AbilityBrimstoneC } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-brimstone-c.webp";
import { default as AbilityBrimstoneE } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-brimstone-e.webp";
import { default as AbilityBrimstoneQ } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-brimstone-q.webp";
import { default as AbilityBrimstoneUlt } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-brimstone-ult.webp";
import { default as AbilityChamberC } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-chamber-c.webp";
import { default as AbilityChamberE } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-chamber-e.webp";
import { default as AbilityChamberQ } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-chamber-q.webp";
import { default as AbilityChamberUlt } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-chamber-ult.webp";
import { default as AbilityCloveC } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-clove-c.webp";
import { default as AbilityCloveE } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-clove-e.webp";
import { default as AbilityCloveQ } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-clove-q.webp";
import { default as AbilityCloveUlt } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-clove-ult.webp";
import { default as AbilityCypherC } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-cypher-c.webp";
import { default as AbilityCypherE } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-cypher-e.webp";
import { default as AbilityCypherQ } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-cypher-q.webp";
import { default as AbilityCypherUlt } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-cypher-ult.webp";
import { default as AbilityDeadlockC } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-deadlock-c.webp";
import { default as AbilityDeadlockE } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-deadlock-e.webp";
import { default as AbilityDeadlockQ } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-deadlock-q.webp";
import { default as AbilityDeadlockUlt } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-deadlock-ult.webp";
import { default as AbilityFadeC } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-fade-c.webp";
import { default as AbilityFadeE } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-fade-e.webp";
import { default as AbilityFadeQ } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-fade-q.webp";
import { default as AbilityFadeUlt } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-fade-ult.webp";
import { default as AbilityGekkoC } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-gekko-c.webp";
import { default as AbilityGekkoE } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-gekko-e.webp";
import { default as AbilityGekkoQ } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-gekko-q.webp";
import { default as AbilityGekkoUlt } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-gekko-ult.webp";
import { default as AbilityHarborC } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-harbor-c.webp";
import { default as AbilityHarborE } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-harbor-e.webp";
import { default as AbilityHarborQ } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-harbor-q.webp";
import { default as AbilityHarborUlt } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-harbor-ult.webp";
import { default as AbilityIsoC } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-iso-c.webp";
import { default as AbilityIsoE } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-iso-e.webp";
import { default as AbilityIsoQ } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-iso-q.webp";
import { default as AbilityIsoUlt } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-iso-ult.webp";
import { default as AbilityJettC } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-jett-c.webp";
import { default as AbilityJettE } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-jett-e.webp";
import { default as AbilityJettPassive } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-jett-passive.webp";
import { default as AbilityJettQ } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-jett-q.webp";
import { default as AbilityJettUlt } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-jett-ult.webp";
import { default as AbilityKayoC } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-kayo-c.webp";
import { default as AbilityKayoE } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-kayo-e.webp";
import { default as AbilityKayoQ } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-kayo-q.webp";
import { default as AbilityKayoUlt } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-kayo-ult.webp";
import { default as AbilityKilljoyC } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-killjoy-c.webp";
import { default as AbilityKilljoyE } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-killjoy-e.webp";
import { default as AbilityKilljoyQ } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-killjoy-q.webp";
import { default as AbilityKilljoyUlt } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-killjoy-ult.webp";
import { default as AbilityNeonC } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-neon-c.webp";
import { default as AbilityNeonE } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-neon-e.webp";
import { default as AbilityNeonQ } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-neon-q.webp";
import { default as AbilityNeonUlt } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-neon-ult.webp";
import { default as AbilityOmenC } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-omen-c.webp";
import { default as AbilityOmenE } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-omen-e.webp";
import { default as AbilityOmenQ } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-omen-q.webp";
import { default as AbilityOmenUlt } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-omen-ult.webp";
import { default as AbilityPhoenixC } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-phoenix-c.webp";
import { default as AbilityPhoenixE } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-phoenix-e.webp";
import { default as AbilityPhoenixQ } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-phoenix-q.webp";
import { default as AbilityPhoenixUlt } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-phoenix-ult.webp";
import { default as AbilityRazeC } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-raze-c.webp";
import { default as AbilityRazeE } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-raze-e.webp";
import { default as AbilityRazeQ } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-raze-q.webp";
import { default as AbilityRazeUlt } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-raze-ult.webp";
import { default as AbilityReynaC } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-reyna-c.webp";
import { default as AbilityReynaE } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-reyna-e.webp";
import { default as AbilityReynaQ } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-reyna-q.webp";
import { default as AbilityReynaUlt } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-reyna-ult.webp";
import { default as AbilitySageC } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-sage-c.webp";
import { default as AbilitySageE } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-sage-e.webp";
import { default as AbilitySageQ } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-sage-q.webp";
import { default as AbilitySageUlt } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-sage-ult.webp";
import { default as AbilitySkyeC } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-skye-c.webp";
import { default as AbilitySkyeE } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-skye-e.webp";
import { default as AbilitySkyeQ } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-skye-q.webp";
import { default as AbilitySkyeUlt } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-skye-ult.webp";
import { default as AbilitySovaC } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-sova-c.webp";
import { default as AbilitySovaE } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-sova-e.webp";
import { default as AbilitySovaQ } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-sova-q.webp";
import { default as AbilitySovaUlt } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-sova-ult.webp";
import { default as AbilityTejoC } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-tejo-c.webp";
import { default as AbilityTejoE } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-tejo-e.webp";
import { default as AbilityTejoQ } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-tejo-q.webp";
import { default as AbilityTejoUlt } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-tejo-ult.webp";
import { default as AbilityViperC } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-viper-c.webp";
import { default as AbilityViperE } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-viper-e.webp";
import { default as AbilityViperQ } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-viper-q.webp";
import { default as AbilityViperUlt } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-viper-ult.webp";
import { default as AbilityVyseC } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-vyse-c.webp";
import { default as AbilityVyseE } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-vyse-e.webp";
import { default as AbilityVyseQ } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-vyse-q.webp";
import { default as AbilityVyseUlt } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-vyse-ult.webp";
import { default as AbilityWaylayC } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-waylay-c.webp";
import { default as AbilityWaylayE } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-waylay-e.webp";
import { default as AbilityWaylayQ } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-waylay-q.webp";
import { default as AbilityWaylayUlt } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-waylay-ult.webp";
import { default as AbilityYoruC } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-yoru-c.webp";
import { default as AbilityYoruE } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-yoru-e.webp";
import { default as AbilityYoruQ } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-yoru-q.webp";
import { default as AbilityYoruUlt } from "@ugitgud/legos/assets/lib/valorant/icon/abilities/ability-yoru-ult.webp";
import { default as AgentAstra } from "@ugitgud/legos/assets/lib/valorant/icon/agents/agent-astra.webp";
import { default as AgentBreach } from "@ugitgud/legos/assets/lib/valorant/icon/agents/agent-breach.webp";
import { default as AgentBrimstone } from "@ugitgud/legos/assets/lib/valorant/icon/agents/agent-brimstone.webp";
import { default as AgentChamber } from "@ugitgud/legos/assets/lib/valorant/icon/agents/agent-chamber.webp";
import { default as AgentClove } from "@ugitgud/legos/assets/lib/valorant/icon/agents/agent-clove.webp";
import { default as AgentCypher } from "@ugitgud/legos/assets/lib/valorant/icon/agents/agent-cypher.webp";
import { default as AgentDeadlock } from "@ugitgud/legos/assets/lib/valorant/icon/agents/agent-deadlock.webp";
import { default as AgentFade } from "@ugitgud/legos/assets/lib/valorant/icon/agents/agent-fade.webp";
import { default as AgentGekko } from "@ugitgud/legos/assets/lib/valorant/icon/agents/agent-gekko.webp";
import { default as AgentHarbor } from "@ugitgud/legos/assets/lib/valorant/icon/agents/agent-harbor.webp";
import { default as AgentIso } from "@ugitgud/legos/assets/lib/valorant/icon/agents/agent-iso.webp";
import { default as AgentJett } from "@ugitgud/legos/assets/lib/valorant/icon/agents/agent-jett.webp";
import { default as AgentKayo } from "@ugitgud/legos/assets/lib/valorant/icon/agents/agent-kayo.webp";
import { default as AgentKilljoy } from "@ugitgud/legos/assets/lib/valorant/icon/agents/agent-killjoy.webp";
import { default as AgentNeon } from "@ugitgud/legos/assets/lib/valorant/icon/agents/agent-neon.webp";
import { default as AgentOmen } from "@ugitgud/legos/assets/lib/valorant/icon/agents/agent-omen.webp";
import { default as AgentPhoenix } from "@ugitgud/legos/assets/lib/valorant/icon/agents/agent-phoenix.webp";
import { default as AgentRaze } from "@ugitgud/legos/assets/lib/valorant/icon/agents/agent-raze.webp";
import { default as AgentReyna } from "@ugitgud/legos/assets/lib/valorant/icon/agents/agent-reyna.webp";
import { default as AgentSage } from "@ugitgud/legos/assets/lib/valorant/icon/agents/agent-sage.webp";
import { default as AgentSkye } from "@ugitgud/legos/assets/lib/valorant/icon/agents/agent-skye.webp";
import { default as AgentSova } from "@ugitgud/legos/assets/lib/valorant/icon/agents/agent-sova.webp";
import { default as AgentTejo } from "@ugitgud/legos/assets/lib/valorant/icon/agents/agent-tejo.webp";
import { default as AgentViper } from "@ugitgud/legos/assets/lib/valorant/icon/agents/agent-viper.webp";
import { default as AgentVyse } from "@ugitgud/legos/assets/lib/valorant/icon/agents/agent-vyse.webp";
import { default as AgentWaylay } from "@ugitgud/legos/assets/lib/valorant/icon/agents/agent-waylay.webp";
import { default as AgentYoru } from "@ugitgud/legos/assets/lib/valorant/icon/agents/agent-yoru.webp";
import { default as PremierConferenceApac } from "@ugitgud/legos/assets/lib/valorant/icon/premier-conference/premier-conference-apac.webp";
import { default as PremierConferenceAus } from "@ugitgud/legos/assets/lib/valorant/icon/premier-conference/premier-conference-aus.webp";
import { default as PremierConferenceBr } from "@ugitgud/legos/assets/lib/valorant/icon/premier-conference/premier-conference-br.webp";
import { default as PremierConferenceEu } from "@ugitgud/legos/assets/lib/valorant/icon/premier-conference/premier-conference-eu.webp";
import { default as PremierConferenceInd } from "@ugitgud/legos/assets/lib/valorant/icon/premier-conference/premier-conference-ind.webp";
import { default as PremierConferenceJpn } from "@ugitgud/legos/assets/lib/valorant/icon/premier-conference/premier-conference-jpn.webp";
import { default as PremierConferenceKr } from "@ugitgud/legos/assets/lib/valorant/icon/premier-conference/premier-conference-kr.webp";
import { default as PremierConferenceLatam } from "@ugitgud/legos/assets/lib/valorant/icon/premier-conference/premier-conference-latam.webp";
import { default as PremierConferenceMe } from "@ugitgud/legos/assets/lib/valorant/icon/premier-conference/premier-conference-me.webp";
import { default as PremierConferenceNa } from "@ugitgud/legos/assets/lib/valorant/icon/premier-conference/premier-conference-na.webp";
import { default as PremierConferenceTr } from "@ugitgud/legos/assets/lib/valorant/icon/premier-conference/premier-conference-tr.webp";
import { default as PremierConferenceUs } from "@ugitgud/legos/assets/lib/valorant/icon/premier-conference/premier-conference-us.webp";
import { default as PremierDivisionAdvanced } from "@ugitgud/legos/assets/lib/valorant/icon/premier-division/premier-division-advanced.webp";
import { default as PremierDivisionContender } from "@ugitgud/legos/assets/lib/valorant/icon/premier-division/premier-division-contender.webp";
import { default as PremierDivisionElite } from "@ugitgud/legos/assets/lib/valorant/icon/premier-division/premier-division-elite.webp";
import { default as PremierDivisionIntermediate } from "@ugitgud/legos/assets/lib/valorant/icon/premier-division/premier-division-intermediate.webp";
import { default as PremierDivisionInvite } from "@ugitgud/legos/assets/lib/valorant/icon/premier-division/premier-division-invite.webp";
import { default as PremierDivisionOpen } from "@ugitgud/legos/assets/lib/valorant/icon/premier-division/premier-division-open.webp";
import { default as PremierDivisionUnknown } from "@ugitgud/legos/assets/lib/valorant/icon/premier-division/premier-division-unknown.webp";
import { default as Rank_0 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-0.webp";
import { default as Rank_10 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-10.webp";
import { default as Rank_11 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-11.webp";
import { default as Rank_12 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-12.webp";
import { default as Rank_13 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-13.webp";
import { default as Rank_14 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-14.webp";
import { default as Rank_15 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-15.webp";
import { default as Rank_16 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-16.webp";
import { default as Rank_17 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-17.webp";
import { default as Rank_18 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-18.webp";
import { default as Rank_19 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-19.webp";
import { default as Rank_20 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-20.webp";
import { default as Rank_21 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-21.webp";
import { default as Rank_22 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-22.webp";
import { default as Rank_23 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-23.webp";
import { default as Rank_24 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-24.webp";
import { default as Rank_25 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-25.webp";
import { default as Rank_26 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-26.webp";
import { default as Rank_27 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-27.webp";
import { default as Rank_3 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-3.webp";
import { default as Rank_4 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-4.webp";
import { default as Rank_5 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-5.webp";
import { default as Rank_6 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-6.webp";
import { default as Rank_7 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-7.webp";
import { default as Rank_8 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-8.webp";
import { default as Rank_9 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-9.webp";
import { default as RankEp_1_0 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-1-0.webp";
import { default as RankEp_1_10 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-1-10.webp";
import { default as RankEp_1_11 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-1-11.webp";
import { default as RankEp_1_12 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-1-12.webp";
import { default as RankEp_1_13 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-1-13.webp";
import { default as RankEp_1_14 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-1-14.webp";
import { default as RankEp_1_15 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-1-15.webp";
import { default as RankEp_1_16 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-1-16.webp";
import { default as RankEp_1_17 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-1-17.webp";
import { default as RankEp_1_18 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-1-18.webp";
import { default as RankEp_1_19 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-1-19.webp";
import { default as RankEp_1_20 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-1-20.webp";
import { default as RankEp_1_21 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-1-21.webp";
import { default as RankEp_1_22 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-1-22.webp";
import { default as RankEp_1_23 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-1-23.webp";
import { default as RankEp_1_24 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-1-24.webp";
import { default as RankEp_1_3 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-1-3.webp";
import { default as RankEp_1_4 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-1-4.webp";
import { default as RankEp_1_5 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-1-5.webp";
import { default as RankEp_1_6 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-1-6.webp";
import { default as RankEp_1_7 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-1-7.webp";
import { default as RankEp_1_8 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-1-8.webp";
import { default as RankEp_1_9 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-1-9.webp";
import { default as RankEp_2_0 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-2-0.webp";
import { default as RankEp_2_10 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-2-10.webp";
import { default as RankEp_2_11 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-2-11.webp";
import { default as RankEp_2_12 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-2-12.webp";
import { default as RankEp_2_13 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-2-13.webp";
import { default as RankEp_2_14 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-2-14.webp";
import { default as RankEp_2_15 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-2-15.webp";
import { default as RankEp_2_16 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-2-16.webp";
import { default as RankEp_2_17 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-2-17.webp";
import { default as RankEp_2_18 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-2-18.webp";
import { default as RankEp_2_19 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-2-19.webp";
import { default as RankEp_2_20 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-2-20.webp";
import { default as RankEp_2_21 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-2-21.webp";
import { default as RankEp_2_24 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-2-24.webp";
import { default as RankEp_2_3 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-2-3.webp";
import { default as RankEp_2_4 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-2-4.webp";
import { default as RankEp_2_5 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-2-5.webp";
import { default as RankEp_2_6 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-2-6.webp";
import { default as RankEp_2_7 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-2-7.webp";
import { default as RankEp_2_8 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-2-8.webp";
import { default as RankEp_2_9 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-2-9.webp";
import { default as RankEp_3_0 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-3-0.webp";
import { default as RankEp_3_10 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-3-10.webp";
import { default as RankEp_3_11 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-3-11.webp";
import { default as RankEp_3_12 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-3-12.webp";
import { default as RankEp_3_13 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-3-13.webp";
import { default as RankEp_3_14 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-3-14.webp";
import { default as RankEp_3_15 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-3-15.webp";
import { default as RankEp_3_16 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-3-16.webp";
import { default as RankEp_3_17 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-3-17.webp";
import { default as RankEp_3_18 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-3-18.webp";
import { default as RankEp_3_19 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-3-19.webp";
import { default as RankEp_3_20 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-3-20.webp";
import { default as RankEp_3_21 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-3-21.webp";
import { default as RankEp_3_22 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-3-22.webp";
import { default as RankEp_3_23 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-3-23.webp";
import { default as RankEp_3_24 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-3-24.webp";
import { default as RankEp_3_3 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-3-3.webp";
import { default as RankEp_3_4 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-3-4.webp";
import { default as RankEp_3_5 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-3-5.webp";
import { default as RankEp_3_6 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-3-6.webp";
import { default as RankEp_3_7 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-3-7.webp";
import { default as RankEp_3_8 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-3-8.webp";
import { default as RankEp_3_9 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-3-9.webp";
import { default as RankEp_4_0 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-4-0.webp";
import { default as RankEp_4_10 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-4-10.webp";
import { default as RankEp_4_11 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-4-11.webp";
import { default as RankEp_4_12 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-4-12.webp";
import { default as RankEp_4_13 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-4-13.webp";
import { default as RankEp_4_14 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-4-14.webp";
import { default as RankEp_4_15 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-4-15.webp";
import { default as RankEp_4_16 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-4-16.webp";
import { default as RankEp_4_17 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-4-17.webp";
import { default as RankEp_4_18 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-4-18.webp";
import { default as RankEp_4_19 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-4-19.webp";
import { default as RankEp_4_20 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-4-20.webp";
import { default as RankEp_4_21 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-4-21.webp";
import { default as RankEp_4_22 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-4-22.webp";
import { default as RankEp_4_23 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-4-23.webp";
import { default as RankEp_4_24 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-4-24.webp";
import { default as RankEp_4_3 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-4-3.webp";
import { default as RankEp_4_4 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-4-4.webp";
import { default as RankEp_4_5 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-4-5.webp";
import { default as RankEp_4_6 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-4-6.webp";
import { default as RankEp_4_7 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-4-7.webp";
import { default as RankEp_4_8 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-4-8.webp";
import { default as RankEp_4_9 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-4-9.webp";
import { default as RankEp_5_0 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-5-0.webp";
import { default as RankEp_5_10 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-5-10.webp";
import { default as RankEp_5_11 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-5-11.webp";
import { default as RankEp_5_12 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-5-12.webp";
import { default as RankEp_5_13 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-5-13.webp";
import { default as RankEp_5_14 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-5-14.webp";
import { default as RankEp_5_15 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-5-15.webp";
import { default as RankEp_5_16 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-5-16.webp";
import { default as RankEp_5_17 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-5-17.webp";
import { default as RankEp_5_18 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-5-18.webp";
import { default as RankEp_5_19 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-5-19.webp";
import { default as RankEp_5_20 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-5-20.webp";
import { default as RankEp_5_21 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-5-21.webp";
import { default as RankEp_5_22 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-5-22.webp";
import { default as RankEp_5_23 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-5-23.webp";
import { default as RankEp_5_24 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-5-24.webp";
import { default as RankEp_5_25 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-5-25.webp";
import { default as RankEp_5_26 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-5-26.webp";
import { default as RankEp_5_27 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-5-27.webp";
import { default as RankEp_5_3 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-5-3.webp";
import { default as RankEp_5_4 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-5-4.webp";
import { default as RankEp_5_5 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-5-5.webp";
import { default as RankEp_5_6 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-5-6.webp";
import { default as RankEp_5_7 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-5-7.webp";
import { default as RankEp_5_8 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-5-8.webp";
import { default as RankEp_5_9 } from "@ugitgud/legos/assets/lib/valorant/icon/ranks/rank-ep-5-9.webp";
import { default as WeaponAres } from "@ugitgud/legos/assets/lib/valorant/icon/weapons/weapon-ares.webp";
import { default as WeaponBucky } from "@ugitgud/legos/assets/lib/valorant/icon/weapons/weapon-bucky.webp";
import { default as WeaponBulldog } from "@ugitgud/legos/assets/lib/valorant/icon/weapons/weapon-bulldog.webp";
import { default as WeaponClassic } from "@ugitgud/legos/assets/lib/valorant/icon/weapons/weapon-classic.webp";
import { default as WeaponFrenzy } from "@ugitgud/legos/assets/lib/valorant/icon/weapons/weapon-frenzy.webp";
import { default as WeaponGhost } from "@ugitgud/legos/assets/lib/valorant/icon/weapons/weapon-ghost.webp";
import { default as WeaponGuardian } from "@ugitgud/legos/assets/lib/valorant/icon/weapons/weapon-guardian.webp";
import { default as WeaponHeadhunter } from "@ugitgud/legos/assets/lib/valorant/icon/weapons/weapon-headhunter.webp";
import { default as WeaponJudge } from "@ugitgud/legos/assets/lib/valorant/icon/weapons/weapon-judge.webp";
import { default as WeaponMarshal } from "@ugitgud/legos/assets/lib/valorant/icon/weapons/weapon-marshal.webp";
import { default as WeaponMelee } from "@ugitgud/legos/assets/lib/valorant/icon/weapons/weapon-melee.webp";
import { default as WeaponOdin } from "@ugitgud/legos/assets/lib/valorant/icon/weapons/weapon-odin.webp";
import { default as WeaponOperator } from "@ugitgud/legos/assets/lib/valorant/icon/weapons/weapon-operator.webp";
import { default as WeaponOutlaw } from "@ugitgud/legos/assets/lib/valorant/icon/weapons/weapon-outlaw.webp";
import { default as WeaponPhantom } from "@ugitgud/legos/assets/lib/valorant/icon/weapons/weapon-phantom.webp";
import { default as WeaponSheriff } from "@ugitgud/legos/assets/lib/valorant/icon/weapons/weapon-sheriff.webp";
import { default as WeaponShorty } from "@ugitgud/legos/assets/lib/valorant/icon/weapons/weapon-shorty.webp";
import { default as WeaponSpectre } from "@ugitgud/legos/assets/lib/valorant/icon/weapons/weapon-spectre.webp";
import { default as WeaponStinger } from "@ugitgud/legos/assets/lib/valorant/icon/weapons/weapon-stinger.webp";
import { default as WeaponTourDeForce } from "@ugitgud/legos/assets/lib/valorant/icon/weapons/weapon-tour-de-force.webp";
import { default as WeaponVandal } from "@ugitgud/legos/assets/lib/valorant/icon/weapons/weapon-vandal.webp";
export const iconNames = [
  "allstar-logo-purple",
  "ability-astra-c",
  "ability-astra-e",
  "ability-astra-passive",
  "ability-astra-q",
  "ability-astra-ult",
  "ability-breach-c",
  "ability-breach-e",
  "ability-breach-q",
  "ability-breach-ult",
  "ability-brimstone-c",
  "ability-brimstone-e",
  "ability-brimstone-q",
  "ability-brimstone-ult",
  "ability-chamber-c",
  "ability-chamber-e",
  "ability-chamber-q",
  "ability-chamber-ult",
  "ability-clove-c",
  "ability-clove-e",
  "ability-clove-q",
  "ability-clove-ult",
  "ability-cypher-c",
  "ability-cypher-e",
  "ability-cypher-q",
  "ability-cypher-ult",
  "ability-deadlock-c",
  "ability-deadlock-e",
  "ability-deadlock-q",
  "ability-deadlock-ult",
  "ability-fade-c",
  "ability-fade-e",
  "ability-fade-q",
  "ability-fade-ult",
  "ability-gekko-c",
  "ability-gekko-e",
  "ability-gekko-q",
  "ability-gekko-ult",
  "ability-harbor-c",
  "ability-harbor-e",
  "ability-harbor-q",
  "ability-harbor-ult",
  "ability-iso-c",
  "ability-iso-e",
  "ability-iso-q",
  "ability-iso-ult",
  "ability-jett-c",
  "ability-jett-e",
  "ability-jett-passive",
  "ability-jett-q",
  "ability-jett-ult",
  "ability-kayo-c",
  "ability-kayo-e",
  "ability-kayo-q",
  "ability-kayo-ult",
  "ability-killjoy-c",
  "ability-killjoy-e",
  "ability-killjoy-q",
  "ability-killjoy-ult",
  "ability-neon-c",
  "ability-neon-e",
  "ability-neon-q",
  "ability-neon-ult",
  "ability-omen-c",
  "ability-omen-e",
  "ability-omen-q",
  "ability-omen-ult",
  "ability-phoenix-c",
  "ability-phoenix-e",
  "ability-phoenix-q",
  "ability-phoenix-ult",
  "ability-raze-c",
  "ability-raze-e",
  "ability-raze-q",
  "ability-raze-ult",
  "ability-reyna-c",
  "ability-reyna-e",
  "ability-reyna-q",
  "ability-reyna-ult",
  "ability-sage-c",
  "ability-sage-e",
  "ability-sage-q",
  "ability-sage-ult",
  "ability-skye-c",
  "ability-skye-e",
  "ability-skye-q",
  "ability-skye-ult",
  "ability-sova-c",
  "ability-sova-e",
  "ability-sova-q",
  "ability-sova-ult",
  "ability-tejo-c",
  "ability-tejo-e",
  "ability-tejo-q",
  "ability-tejo-ult",
  "ability-viper-c",
  "ability-viper-e",
  "ability-viper-q",
  "ability-viper-ult",
  "ability-vyse-c",
  "ability-vyse-e",
  "ability-vyse-q",
  "ability-vyse-ult",
  "ability-waylay-c",
  "ability-waylay-e",
  "ability-waylay-q",
  "ability-waylay-ult",
  "ability-yoru-c",
  "ability-yoru-e",
  "ability-yoru-q",
  "ability-yoru-ult",
  "agent-astra",
  "agent-breach",
  "agent-brimstone",
  "agent-chamber",
  "agent-clove",
  "agent-cypher",
  "agent-deadlock",
  "agent-fade",
  "agent-gekko",
  "agent-harbor",
  "agent-iso",
  "agent-jett",
  "agent-kayo",
  "agent-killjoy",
  "agent-neon",
  "agent-omen",
  "agent-phoenix",
  "agent-raze",
  "agent-reyna",
  "agent-sage",
  "agent-skye",
  "agent-sova",
  "agent-tejo",
  "agent-viper",
  "agent-vyse",
  "agent-waylay",
  "agent-yoru",
  "premier-conference-apac",
  "premier-conference-aus",
  "premier-conference-br",
  "premier-conference-eu",
  "premier-conference-ind",
  "premier-conference-jpn",
  "premier-conference-kr",
  "premier-conference-latam",
  "premier-conference-me",
  "premier-conference-na",
  "premier-conference-tr",
  "premier-conference-us",
  "premier-division-advanced",
  "premier-division-contender",
  "premier-division-elite",
  "premier-division-intermediate",
  "premier-division-invite",
  "premier-division-open",
  "premier-division-unknown",
  "rank-0",
  "rank-10",
  "rank-11",
  "rank-12",
  "rank-13",
  "rank-14",
  "rank-15",
  "rank-16",
  "rank-17",
  "rank-18",
  "rank-19",
  "rank-20",
  "rank-21",
  "rank-22",
  "rank-23",
  "rank-24",
  "rank-25",
  "rank-26",
  "rank-27",
  "rank-3",
  "rank-4",
  "rank-5",
  "rank-6",
  "rank-7",
  "rank-8",
  "rank-9",
  "rank-ep-1-0",
  "rank-ep-1-10",
  "rank-ep-1-11",
  "rank-ep-1-12",
  "rank-ep-1-13",
  "rank-ep-1-14",
  "rank-ep-1-15",
  "rank-ep-1-16",
  "rank-ep-1-17",
  "rank-ep-1-18",
  "rank-ep-1-19",
  "rank-ep-1-20",
  "rank-ep-1-21",
  "rank-ep-1-22",
  "rank-ep-1-23",
  "rank-ep-1-24",
  "rank-ep-1-3",
  "rank-ep-1-4",
  "rank-ep-1-5",
  "rank-ep-1-6",
  "rank-ep-1-7",
  "rank-ep-1-8",
  "rank-ep-1-9",
  "rank-ep-2-0",
  "rank-ep-2-10",
  "rank-ep-2-11",
  "rank-ep-2-12",
  "rank-ep-2-13",
  "rank-ep-2-14",
  "rank-ep-2-15",
  "rank-ep-2-16",
  "rank-ep-2-17",
  "rank-ep-2-18",
  "rank-ep-2-19",
  "rank-ep-2-20",
  "rank-ep-2-21",
  "rank-ep-2-24",
  "rank-ep-2-3",
  "rank-ep-2-4",
  "rank-ep-2-5",
  "rank-ep-2-6",
  "rank-ep-2-7",
  "rank-ep-2-8",
  "rank-ep-2-9",
  "rank-ep-3-0",
  "rank-ep-3-10",
  "rank-ep-3-11",
  "rank-ep-3-12",
  "rank-ep-3-13",
  "rank-ep-3-14",
  "rank-ep-3-15",
  "rank-ep-3-16",
  "rank-ep-3-17",
  "rank-ep-3-18",
  "rank-ep-3-19",
  "rank-ep-3-20",
  "rank-ep-3-21",
  "rank-ep-3-22",
  "rank-ep-3-23",
  "rank-ep-3-24",
  "rank-ep-3-3",
  "rank-ep-3-4",
  "rank-ep-3-5",
  "rank-ep-3-6",
  "rank-ep-3-7",
  "rank-ep-3-8",
  "rank-ep-3-9",
  "rank-ep-4-0",
  "rank-ep-4-10",
  "rank-ep-4-11",
  "rank-ep-4-12",
  "rank-ep-4-13",
  "rank-ep-4-14",
  "rank-ep-4-15",
  "rank-ep-4-16",
  "rank-ep-4-17",
  "rank-ep-4-18",
  "rank-ep-4-19",
  "rank-ep-4-20",
  "rank-ep-4-21",
  "rank-ep-4-22",
  "rank-ep-4-23",
  "rank-ep-4-24",
  "rank-ep-4-3",
  "rank-ep-4-4",
  "rank-ep-4-5",
  "rank-ep-4-6",
  "rank-ep-4-7",
  "rank-ep-4-8",
  "rank-ep-4-9",
  "rank-ep-5-0",
  "rank-ep-5-10",
  "rank-ep-5-11",
  "rank-ep-5-12",
  "rank-ep-5-13",
  "rank-ep-5-14",
  "rank-ep-5-15",
  "rank-ep-5-16",
  "rank-ep-5-17",
  "rank-ep-5-18",
  "rank-ep-5-19",
  "rank-ep-5-20",
  "rank-ep-5-21",
  "rank-ep-5-22",
  "rank-ep-5-23",
  "rank-ep-5-24",
  "rank-ep-5-25",
  "rank-ep-5-26",
  "rank-ep-5-27",
  "rank-ep-5-3",
  "rank-ep-5-4",
  "rank-ep-5-5",
  "rank-ep-5-6",
  "rank-ep-5-7",
  "rank-ep-5-8",
  "rank-ep-5-9",
  "weapon-ares",
  "weapon-bucky",
  "weapon-bulldog",
  "weapon-classic",
  "weapon-frenzy",
  "weapon-ghost",
  "weapon-guardian",
  "weapon-headhunter",
  "weapon-judge",
  "weapon-marshal",
  "weapon-melee",
  "weapon-odin",
  "weapon-operator",
  "weapon-outlaw",
  "weapon-phantom",
  "weapon-sheriff",
  "weapon-shorty",
  "weapon-spectre",
  "weapon-stinger",
  "weapon-tour-de-force",
  "weapon-vandal",
] as const;
export type IconNames = (typeof iconNames)[number];

export const iconLookup = {
  "allstar-logo-purple": AllstarLogoPurple,
  "ability-astra-c": AbilityAstraC,
  "ability-astra-e": AbilityAstraE,
  "ability-astra-passive": AbilityAstraPassive,
  "ability-astra-q": AbilityAstraQ,
  "ability-astra-ult": AbilityAstraUlt,
  "ability-breach-c": AbilityBreachC,
  "ability-breach-e": AbilityBreachE,
  "ability-breach-q": AbilityBreachQ,
  "ability-breach-ult": AbilityBreachUlt,
  "ability-brimstone-c": AbilityBrimstoneC,
  "ability-brimstone-e": AbilityBrimstoneE,
  "ability-brimstone-q": AbilityBrimstoneQ,
  "ability-brimstone-ult": AbilityBrimstoneUlt,
  "ability-chamber-c": AbilityChamberC,
  "ability-chamber-e": AbilityChamberE,
  "ability-chamber-q": AbilityChamberQ,
  "ability-chamber-ult": AbilityChamberUlt,
  "ability-clove-c": AbilityCloveC,
  "ability-clove-e": AbilityCloveE,
  "ability-clove-q": AbilityCloveQ,
  "ability-clove-ult": AbilityCloveUlt,
  "ability-cypher-c": AbilityCypherC,
  "ability-cypher-e": AbilityCypherE,
  "ability-cypher-q": AbilityCypherQ,
  "ability-cypher-ult": AbilityCypherUlt,
  "ability-deadlock-c": AbilityDeadlockC,
  "ability-deadlock-e": AbilityDeadlockE,
  "ability-deadlock-q": AbilityDeadlockQ,
  "ability-deadlock-ult": AbilityDeadlockUlt,
  "ability-fade-c": AbilityFadeC,
  "ability-fade-e": AbilityFadeE,
  "ability-fade-q": AbilityFadeQ,
  "ability-fade-ult": AbilityFadeUlt,
  "ability-gekko-c": AbilityGekkoC,
  "ability-gekko-e": AbilityGekkoE,
  "ability-gekko-q": AbilityGekkoQ,
  "ability-gekko-ult": AbilityGekkoUlt,
  "ability-harbor-c": AbilityHarborC,
  "ability-harbor-e": AbilityHarborE,
  "ability-harbor-q": AbilityHarborQ,
  "ability-harbor-ult": AbilityHarborUlt,
  "ability-iso-c": AbilityIsoC,
  "ability-iso-e": AbilityIsoE,
  "ability-iso-q": AbilityIsoQ,
  "ability-iso-ult": AbilityIsoUlt,
  "ability-jett-c": AbilityJettC,
  "ability-jett-e": AbilityJettE,
  "ability-jett-passive": AbilityJettPassive,
  "ability-jett-q": AbilityJettQ,
  "ability-jett-ult": AbilityJettUlt,
  "ability-kayo-c": AbilityKayoC,
  "ability-kayo-e": AbilityKayoE,
  "ability-kayo-q": AbilityKayoQ,
  "ability-kayo-ult": AbilityKayoUlt,
  "ability-killjoy-c": AbilityKilljoyC,
  "ability-killjoy-e": AbilityKilljoyE,
  "ability-killjoy-q": AbilityKilljoyQ,
  "ability-killjoy-ult": AbilityKilljoyUlt,
  "ability-neon-c": AbilityNeonC,
  "ability-neon-e": AbilityNeonE,
  "ability-neon-q": AbilityNeonQ,
  "ability-neon-ult": AbilityNeonUlt,
  "ability-omen-c": AbilityOmenC,
  "ability-omen-e": AbilityOmenE,
  "ability-omen-q": AbilityOmenQ,
  "ability-omen-ult": AbilityOmenUlt,
  "ability-phoenix-c": AbilityPhoenixC,
  "ability-phoenix-e": AbilityPhoenixE,
  "ability-phoenix-q": AbilityPhoenixQ,
  "ability-phoenix-ult": AbilityPhoenixUlt,
  "ability-raze-c": AbilityRazeC,
  "ability-raze-e": AbilityRazeE,
  "ability-raze-q": AbilityRazeQ,
  "ability-raze-ult": AbilityRazeUlt,
  "ability-reyna-c": AbilityReynaC,
  "ability-reyna-e": AbilityReynaE,
  "ability-reyna-q": AbilityReynaQ,
  "ability-reyna-ult": AbilityReynaUlt,
  "ability-sage-c": AbilitySageC,
  "ability-sage-e": AbilitySageE,
  "ability-sage-q": AbilitySageQ,
  "ability-sage-ult": AbilitySageUlt,
  "ability-skye-c": AbilitySkyeC,
  "ability-skye-e": AbilitySkyeE,
  "ability-skye-q": AbilitySkyeQ,
  "ability-skye-ult": AbilitySkyeUlt,
  "ability-sova-c": AbilitySovaC,
  "ability-sova-e": AbilitySovaE,
  "ability-sova-q": AbilitySovaQ,
  "ability-sova-ult": AbilitySovaUlt,
  "ability-tejo-c": AbilityTejoC,
  "ability-tejo-e": AbilityTejoE,
  "ability-tejo-q": AbilityTejoQ,
  "ability-tejo-ult": AbilityTejoUlt,
  "ability-viper-c": AbilityViperC,
  "ability-viper-e": AbilityViperE,
  "ability-viper-q": AbilityViperQ,
  "ability-viper-ult": AbilityViperUlt,
  "ability-vyse-c": AbilityVyseC,
  "ability-vyse-e": AbilityVyseE,
  "ability-vyse-q": AbilityVyseQ,
  "ability-vyse-ult": AbilityVyseUlt,
  "ability-waylay-c": AbilityWaylayC,
  "ability-waylay-e": AbilityWaylayE,
  "ability-waylay-q": AbilityWaylayQ,
  "ability-waylay-ult": AbilityWaylayUlt,
  "ability-yoru-c": AbilityYoruC,
  "ability-yoru-e": AbilityYoruE,
  "ability-yoru-q": AbilityYoruQ,
  "ability-yoru-ult": AbilityYoruUlt,
  "agent-astra": AgentAstra,
  "agent-breach": AgentBreach,
  "agent-brimstone": AgentBrimstone,
  "agent-chamber": AgentChamber,
  "agent-clove": AgentClove,
  "agent-cypher": AgentCypher,
  "agent-deadlock": AgentDeadlock,
  "agent-fade": AgentFade,
  "agent-gekko": AgentGekko,
  "agent-harbor": AgentHarbor,
  "agent-iso": AgentIso,
  "agent-jett": AgentJett,
  "agent-kayo": AgentKayo,
  "agent-killjoy": AgentKilljoy,
  "agent-neon": AgentNeon,
  "agent-omen": AgentOmen,
  "agent-phoenix": AgentPhoenix,
  "agent-raze": AgentRaze,
  "agent-reyna": AgentReyna,
  "agent-sage": AgentSage,
  "agent-skye": AgentSkye,
  "agent-sova": AgentSova,
  "agent-tejo": AgentTejo,
  "agent-viper": AgentViper,
  "agent-vyse": AgentVyse,
  "agent-waylay": AgentWaylay,
  "agent-yoru": AgentYoru,
  "premier-conference-apac": PremierConferenceApac,
  "premier-conference-aus": PremierConferenceAus,
  "premier-conference-br": PremierConferenceBr,
  "premier-conference-eu": PremierConferenceEu,
  "premier-conference-ind": PremierConferenceInd,
  "premier-conference-jpn": PremierConferenceJpn,
  "premier-conference-kr": PremierConferenceKr,
  "premier-conference-latam": PremierConferenceLatam,
  "premier-conference-me": PremierConferenceMe,
  "premier-conference-na": PremierConferenceNa,
  "premier-conference-tr": PremierConferenceTr,
  "premier-conference-us": PremierConferenceUs,
  "premier-division-advanced": PremierDivisionAdvanced,
  "premier-division-contender": PremierDivisionContender,
  "premier-division-elite": PremierDivisionElite,
  "premier-division-intermediate": PremierDivisionIntermediate,
  "premier-division-invite": PremierDivisionInvite,
  "premier-division-open": PremierDivisionOpen,
  "premier-division-unknown": PremierDivisionUnknown,
  "rank-0": Rank_0,
  "rank-10": Rank_10,
  "rank-11": Rank_11,
  "rank-12": Rank_12,
  "rank-13": Rank_13,
  "rank-14": Rank_14,
  "rank-15": Rank_15,
  "rank-16": Rank_16,
  "rank-17": Rank_17,
  "rank-18": Rank_18,
  "rank-19": Rank_19,
  "rank-20": Rank_20,
  "rank-21": Rank_21,
  "rank-22": Rank_22,
  "rank-23": Rank_23,
  "rank-24": Rank_24,
  "rank-25": Rank_25,
  "rank-26": Rank_26,
  "rank-27": Rank_27,
  "rank-3": Rank_3,
  "rank-4": Rank_4,
  "rank-5": Rank_5,
  "rank-6": Rank_6,
  "rank-7": Rank_7,
  "rank-8": Rank_8,
  "rank-9": Rank_9,
  "rank-ep-1-0": RankEp_1_0,
  "rank-ep-1-10": RankEp_1_10,
  "rank-ep-1-11": RankEp_1_11,
  "rank-ep-1-12": RankEp_1_12,
  "rank-ep-1-13": RankEp_1_13,
  "rank-ep-1-14": RankEp_1_14,
  "rank-ep-1-15": RankEp_1_15,
  "rank-ep-1-16": RankEp_1_16,
  "rank-ep-1-17": RankEp_1_17,
  "rank-ep-1-18": RankEp_1_18,
  "rank-ep-1-19": RankEp_1_19,
  "rank-ep-1-20": RankEp_1_20,
  "rank-ep-1-21": RankEp_1_21,
  "rank-ep-1-22": RankEp_1_22,
  "rank-ep-1-23": RankEp_1_23,
  "rank-ep-1-24": RankEp_1_24,
  "rank-ep-1-3": RankEp_1_3,
  "rank-ep-1-4": RankEp_1_4,
  "rank-ep-1-5": RankEp_1_5,
  "rank-ep-1-6": RankEp_1_6,
  "rank-ep-1-7": RankEp_1_7,
  "rank-ep-1-8": RankEp_1_8,
  "rank-ep-1-9": RankEp_1_9,
  "rank-ep-2-0": RankEp_2_0,
  "rank-ep-2-10": RankEp_2_10,
  "rank-ep-2-11": RankEp_2_11,
  "rank-ep-2-12": RankEp_2_12,
  "rank-ep-2-13": RankEp_2_13,
  "rank-ep-2-14": RankEp_2_14,
  "rank-ep-2-15": RankEp_2_15,
  "rank-ep-2-16": RankEp_2_16,
  "rank-ep-2-17": RankEp_2_17,
  "rank-ep-2-18": RankEp_2_18,
  "rank-ep-2-19": RankEp_2_19,
  "rank-ep-2-20": RankEp_2_20,
  "rank-ep-2-21": RankEp_2_21,
  "rank-ep-2-24": RankEp_2_24,
  "rank-ep-2-3": RankEp_2_3,
  "rank-ep-2-4": RankEp_2_4,
  "rank-ep-2-5": RankEp_2_5,
  "rank-ep-2-6": RankEp_2_6,
  "rank-ep-2-7": RankEp_2_7,
  "rank-ep-2-8": RankEp_2_8,
  "rank-ep-2-9": RankEp_2_9,
  "rank-ep-3-0": RankEp_3_0,
  "rank-ep-3-10": RankEp_3_10,
  "rank-ep-3-11": RankEp_3_11,
  "rank-ep-3-12": RankEp_3_12,
  "rank-ep-3-13": RankEp_3_13,
  "rank-ep-3-14": RankEp_3_14,
  "rank-ep-3-15": RankEp_3_15,
  "rank-ep-3-16": RankEp_3_16,
  "rank-ep-3-17": RankEp_3_17,
  "rank-ep-3-18": RankEp_3_18,
  "rank-ep-3-19": RankEp_3_19,
  "rank-ep-3-20": RankEp_3_20,
  "rank-ep-3-21": RankEp_3_21,
  "rank-ep-3-22": RankEp_3_22,
  "rank-ep-3-23": RankEp_3_23,
  "rank-ep-3-24": RankEp_3_24,
  "rank-ep-3-3": RankEp_3_3,
  "rank-ep-3-4": RankEp_3_4,
  "rank-ep-3-5": RankEp_3_5,
  "rank-ep-3-6": RankEp_3_6,
  "rank-ep-3-7": RankEp_3_7,
  "rank-ep-3-8": RankEp_3_8,
  "rank-ep-3-9": RankEp_3_9,
  "rank-ep-4-0": RankEp_4_0,
  "rank-ep-4-10": RankEp_4_10,
  "rank-ep-4-11": RankEp_4_11,
  "rank-ep-4-12": RankEp_4_12,
  "rank-ep-4-13": RankEp_4_13,
  "rank-ep-4-14": RankEp_4_14,
  "rank-ep-4-15": RankEp_4_15,
  "rank-ep-4-16": RankEp_4_16,
  "rank-ep-4-17": RankEp_4_17,
  "rank-ep-4-18": RankEp_4_18,
  "rank-ep-4-19": RankEp_4_19,
  "rank-ep-4-20": RankEp_4_20,
  "rank-ep-4-21": RankEp_4_21,
  "rank-ep-4-22": RankEp_4_22,
  "rank-ep-4-23": RankEp_4_23,
  "rank-ep-4-24": RankEp_4_24,
  "rank-ep-4-3": RankEp_4_3,
  "rank-ep-4-4": RankEp_4_4,
  "rank-ep-4-5": RankEp_4_5,
  "rank-ep-4-6": RankEp_4_6,
  "rank-ep-4-7": RankEp_4_7,
  "rank-ep-4-8": RankEp_4_8,
  "rank-ep-4-9": RankEp_4_9,
  "rank-ep-5-0": RankEp_5_0,
  "rank-ep-5-10": RankEp_5_10,
  "rank-ep-5-11": RankEp_5_11,
  "rank-ep-5-12": RankEp_5_12,
  "rank-ep-5-13": RankEp_5_13,
  "rank-ep-5-14": RankEp_5_14,
  "rank-ep-5-15": RankEp_5_15,
  "rank-ep-5-16": RankEp_5_16,
  "rank-ep-5-17": RankEp_5_17,
  "rank-ep-5-18": RankEp_5_18,
  "rank-ep-5-19": RankEp_5_19,
  "rank-ep-5-20": RankEp_5_20,
  "rank-ep-5-21": RankEp_5_21,
  "rank-ep-5-22": RankEp_5_22,
  "rank-ep-5-23": RankEp_5_23,
  "rank-ep-5-24": RankEp_5_24,
  "rank-ep-5-25": RankEp_5_25,
  "rank-ep-5-26": RankEp_5_26,
  "rank-ep-5-27": RankEp_5_27,
  "rank-ep-5-3": RankEp_5_3,
  "rank-ep-5-4": RankEp_5_4,
  "rank-ep-5-5": RankEp_5_5,
  "rank-ep-5-6": RankEp_5_6,
  "rank-ep-5-7": RankEp_5_7,
  "rank-ep-5-8": RankEp_5_8,
  "rank-ep-5-9": RankEp_5_9,
  "weapon-ares": WeaponAres,
  "weapon-bucky": WeaponBucky,
  "weapon-bulldog": WeaponBulldog,
  "weapon-classic": WeaponClassic,
  "weapon-frenzy": WeaponFrenzy,
  "weapon-ghost": WeaponGhost,
  "weapon-guardian": WeaponGuardian,
  "weapon-headhunter": WeaponHeadhunter,
  "weapon-judge": WeaponJudge,
  "weapon-marshal": WeaponMarshal,
  "weapon-melee": WeaponMelee,
  "weapon-odin": WeaponOdin,
  "weapon-operator": WeaponOperator,
  "weapon-outlaw": WeaponOutlaw,
  "weapon-phantom": WeaponPhantom,
  "weapon-sheriff": WeaponSheriff,
  "weapon-shorty": WeaponShorty,
  "weapon-spectre": WeaponSpectre,
  "weapon-stinger": WeaponStinger,
  "weapon-tour-de-force": WeaponTourDeForce,
  "weapon-vandal": WeaponVandal,
};
